/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter some text to inspect each character.`)
};

const es_ci_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa texto para inspeccionar cada carácter.`)
};

const de_ci_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie Text ein, um jedes Zeichen zu untersuchen.`)
};

const nl_ci_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer wat tekst in om elk karakter te controleren.`)
};

const fr_ci_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez du texte pour inspecter chaque caractère.`)
};

const it_ci_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci del testo per ispezionare ogni carattere.`)
};

const pt_br2_ci_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite algum texto para inspecionar cada caractere.`)
};

const pt_ci_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza algum texto para inspecionar cada carácter.`)
};

const ja_ci_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「テキストを入力して各文字を調べてください。」`)
};

const zh_ci_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入一些文本以检查每个字符。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_empty", locale)
	if (locale === "en") return en_ci_empty(inputs)
	if (locale === "es") return es_ci_empty(inputs)
	if (locale === "de") return de_ci_empty(inputs)
	if (locale === "nl") return nl_ci_empty(inputs)
	if (locale === "fr") return fr_ci_empty(inputs)
	if (locale === "it") return it_ci_empty(inputs)
	if (locale === "pt-BR") return pt_br2_ci_empty(inputs)
	if (locale === "pt") return pt_ci_empty(inputs)
	if (locale === "ja") return ja_ci_empty(inputs)
	return zh_ci_empty(inputs)
};